import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { ContractManagementService } from '../contract-management/contract-management.service';
import { ContractManagementFeaturesComponent } from '../contract-management/features/contract-management-features.component';
import { processResolver } from './process-resolver';

const log = new LoggingService();
export const ContractMgmtRoute: Ng2StateDeclaration = {
    name: 'contractmgmt',
    url: '/contractmgmt',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: ContractManagementFeaturesComponent
};
